// @flow
import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import cookiesPolicy from 'fg-frontend/components/CookiesPolicy4/index';
import phoneLink from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
//import('./components/plUpload/fg.upload');                // PL upload
//import 'bootstrap/js/dist/collapse';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
cookiesPolicy({
  enableTechnicalButton: true,
});
phoneLink();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-kanken/src/js/configureWeb.js